import type { OilPhaseVolumeFactorCalculator } from "../../d";

import { oilPhaseVolumeFactorBoCalculator } from "./oilPhaseVolumeFactorBoCalculator";
import { bubblePointPressurePSIACalculator } from "./bubblePointPressurePSIACalculator";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const oilPhaseVolumeFactorCalculator: OilPhaseVolumeFactorCalculator = {
  solutionGasRsoCalculator,
  bubblePointPressurePSIACalculator,
  oilPhaseVolumeFactorBoCalculator
};
